import { connect } from 'react-redux';
import { postDataToBridgeAPI } from '../../../services/aventriService';
import RegistraionComponent from './RegistraionComponent';
import { getUserInfo } from 'helpers/utilCommon';

const mapStateToProps = (state) => ({
    userInfo: getUserInfo()
})

const mapDispatchToProps = dispatch => ({
    postDataToBridgeAPI: (data, callback) => { postDataToBridgeAPI(data, dispatch, callback) }
})

const RegistraionContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(RegistraionComponent);

export default RegistraionContainer;